import { render, staticRenderFns } from "./SubmitClip.vue?vue&type=template&id=22b8eaa7&scoped=true&"
import script from "./SubmitClip.vue?vue&type=script&lang=js&"
export * from "./SubmitClip.vue?vue&type=script&lang=js&"
import style0 from "./SubmitClip.vue?vue&type=style&index=0&id=22b8eaa7&lang=stylus&scoped=true&"
import style1 from "./SubmitClip.vue?vue&type=style&index=1&id=22b8eaa7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b8eaa7",
  null
  
)

export default component.exports